export default {
  title: 'Contact information',
  form: {
    customer_first_name: {
      placeholder: 'First name',
    },
    customer_last_name: {
      placeholder: 'Last name',
    },
    customer_email: {
      placeholder: 'Email address',
    },
    customer_phone_number: {
      placeholder: 'Phone number',
    },
  },
  validation: {
    customer_first_name: {
      required: 'Please enter your first name',
    },
    customer_last_name: {
      required: 'Please enter your last name',
    },
    customer_email: {
      required: 'Please enter your email',
    },
    customer_phone_number: {
      required: 'Please enter your phone number',
    },
  },
};
